<template>
  <div class="mt-3 mt-md-0">
    <div class="intro-banner text-white text-xl">
      <p>{{ $t('AiHome.rule.Friendly_Reminder') }}</p>
    </div>
    <!-- 書信 -->
    <div class="intro-text bg-white p-4 text-lg" v-if="($route.name === 'ai_assistantMain') && aiType === 'letter'">
      <h6 class="mb-1 font-bold text-lg">{{ $t('AiHome.rule.Total_Points') }}：<span>{{ Number(remainPoints) }}</span> {{ $t('AiHome.rule.point') }}
        <a @click="swal_remainPoints" class="pointer"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.<path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg></a>
      </h6>
      <h6 class="font-bold text-lg">{{ $t('AiHome.rule.per_letter_generation') }}：<span>20</span> {{ $t('AiHome.rule.point') }}</h6>
      <ul class="generate_ul">
        <li><p><span class="title">{{ $t('AiHome.rule.Instructions') }}：</span>{{ $t('AiHome.rule.letter_inst_desc') }}</p></li>
        <li><p><span class="title">{{ $t('AiHome.rule.Definition') }}：</span>{{ $t('AiHome.rule.letter_def_desc') }}</p></li>
        <li><p><span class="title">{{ $t('AiHome.rule.privacy_and_security') }}：</span>{{ $t('AiHome.rule.letter_privacy_desc') }}</p></li>
        <li><p><span class="title">{{ $t('AiHome.rule.review_again') }}：</span>{{ $t('AiHome.rule.letter_review_desc') }}</p></li>
      </ul>
    </div>

    <!-- 演講稿 -->
    <div class="intro-text bg-white p-4 text-lg" v-if="$route.name === 'ai_assistantMain' && aiType === 'speech'">
      <h6 @click="swal_remainPoints" class="mb-1 font-bold text-lg">{{ $t('AiHome.rule.Total_Points') }}：<span>{{ Number(remainPoints) }}</span> {{ $t('AiHome.rule.point') }}
        <a @click="swal_remainPoints" class="pointer"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.<path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg></a>
      </h6>
      <h6 class="font-bold text-lg">{{ $t('AiHome.rule.per_speech_generation') }}：<span>20</span> {{ $t('AiHome.rule.point') }}</h6>
      <ul class="generate_ul">
        <li><p><span class="title">{{ $t('AiHome.rule.Instructions') }}：</span>{{ $t('AiHome.rule.speech_inst_desc') }}</p></li>
        <li><p><span class="title">{{ $t('AiHome.rule.AI_Generation') }}：</span>{{ $t('AiHome.rule.speech_gen_desc') }}</p></li>
        <li><p><span class="title">{{ $t('AiHome.rule.Note') }}：</span>{{ $t('AiHome.rule.speech_note_desc') }}</p></li>
        <!-- <li><p><span class="title">再次核對：</span>本篇英文演講稿為 AI 小助教自動生成，建議使用前再次斟酌核對相關細節。</p></li> -->
      </ul>
    </div>

    <!-- 批改 -->
    <div class="intro-text bg-white p-4 text-lg" v-if="$route.name === 'ai_assistant_correction' || $route.params.generateType === 'correct'">
      <h6 @click="swal_remainPoints" class="mb-1 font-bold text-lg">{{ $t('AiHome.rule.Total_Points') }}：<span>{{ Number(remainPoints) }}</span> {{ $t('AiHome.rule.point') }}
        <a @click="swal_remainPoints" class="pointer"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.<path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg></a>
      </h6>
      <h6 class="font-bold text-lg mb-3">{{ aiType === 'letter' ? $t('AiHome.rule.letter') : $t('AiHome.rule.speech') }}{{ $t('AiHome.rule.per_AI_generation') }}：<span>20</span> {{ $t('AiHome.rule.point') }}</h6>
      <!-- <h6 class="font-bold text-lg">操作說明：</h6> -->
      <ul class="chat_ul_none">
        <li><p><span class="title">{{ $t('AiHome.rule.Instructions') }}：</span>{{ $t('AiHome.rule.correct_inst_desc') }}</p></li>
        <li><p><span class="title">{{ $t('AiHome.rule.AI_Review_Instructions') }}：</span>{{ $t('AiHome.rule.correct_review_desc') }}</p></li>
        <li><p><span class="title">{{ $t('AiHome.rule.Note') }}：</span>{{ $t('AiHome.rule.correct_note_desc', { type: aiType === 'speech' ? $t('AiHome.rule.speech') : $t('AiHome.rule.commercial_letter') }) }}</p></li>
      </ul>
    </div>

    <!-- 跟讀 -->
    <div class="intro-text bg-white p-4 text-lg" v-if="$route.name === 'ai_assistant_follow'">
      <h6 @click="swal_remainPoints" class="mb-1 font-bold text-lg">{{ $t('AiHome.rule.Total_Points') }}：<span>{{ Number(remainPoints) }}</span> {{ $t('AiHome.rule.point') }}
        <a @click="swal_remainPoints" class="pointer"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">!Font Awesome Free 6.5.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2024 Fonticons, Inc.<path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM169.8 165.3c7.9-22.3 29.1-37.3 52.8-37.3h58.3c34.9 0 63.1 28.3 63.1 63.1c0 22.6-12.1 43.5-31.7 54.8L280 264.4c-.2 13-10.9 23.6-24 23.6c-13.3 0-24-10.7-24-24V250.5c0-8.6 4.6-16.5 12.1-20.8l44.3-25.4c4.7-2.7 7.6-7.7 7.6-13.1c0-8.4-6.8-15.1-15.1-15.1H222.6c-3.4 0-6.4 2.1-7.5 5.3l-.4 1.2c-4.4 12.5-18.2 19-30.6 14.6s-19-18.2-14.6-30.6l.4-1.2zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z"/></svg></a>
      </h6>
      <h6 class="font-bold text-lg">{{ $t('AiHome.rule.Instructions') }}：</h6>
      <ul class="chat_ul">
        <li><p class="mb-2">{{ $t('AiHome.rule.follow_mic') }}<img src="@/assets/image/ai/mic_C.png" alt="" class="d-inline-block icon-img m-1">{{ $t('AiHome.rule.follow_mic_desc') }}</p></li>
        <li><p class="mb-2">{{ $t('AiHome.rule.follow_play') }}<img src="@/assets/image/ai/icon_voice_2.png" alt="" class="d-inline-block icon-img m-1">{{ $t('AiHome.rule.follow_play_desc') }}</p></li>
        <li><p class="mb-2">{{ $t('AiHome.rule.follow_my_record') }}<img src="@/assets/image/ai/follow_icon_talk.png" alt="" class="d-inline-block icon-img m-1">{{ $t('AiHome.rule.follow_my_record_desc') }}</p></li>
        <li><p class="mb-2">{{ $t('AiHome.rule.follow_history') }}<img src="@/assets/image/ai/icon_info_record.png" class="d-inline-block icon-img m-1">{{ $t('AiHome.rule.follow_history_desc') }}</p></li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'Rule',
  props: {
    aiType: {
      type: String,
      default: 'letter'
    }
  },
  computed: {
    ...mapGetters([
      'remainPoints'
    ])
  },
  methods: {
    swal_remainPoints () {
      let self = this
      self.$swal({
        html: `<h6>${self.$t('AiHome.swal.current_points')}<span class="text-red-main-ai">${self.remainPoints}</span> ${self.$t('AiHome.rule.point')}</h6>
               <p>${self.$t('AiHome.swal.points_desc')}</p>
               <ul>
                 <li>${self.$t('AiHome.swal.speaking_practice')}</li>
                 <li>${self.$t('AiHome.swal.business_letter')}</li>
                 <li>${self.$t('AiHome.swal.speech_script')}</li>
               </ul>`,
        showCloseButton: false,
        focusConfirm: false,
        confirmButtonText: self.$t('AiHome.swal.got_it'),
        title: self.$t('AiHome.swal.rules_title'),
        customClass: {
          title: 'text-white',
          container: '',
          popup: 'p-0',
          header: 'swal-header-notice justify-content-center align-items-center',
          closeButton: '',
          htmlContainer: 'remainPoints_swal my-3',
          actions: 'mb-4 mt-2',
          confirmButton: 'btn-submit',
          cancelButton: 'bg-red-main-ai',
        }
      }).then((result) => {
        if (result.isConfirmed) {
          self.postData()
        }
      }
      )
    }
  }
}
</script>
<style lang="scss" scoped>
  .intro-banner {
    padding-top: 5rem;
    padding-bottom: 5rem;
    background: #0E103E;
    text-align: center;
    font-weight: 700;
    background-image:
      url('~@/assets/image/ai/plusSS.png'), url('~@/assets/image/ai/plusSS.png'),
      url('~@/assets/image/ai/plusS.png'), url('~@/assets/image/ai/plusS.png'),
      url('~@/assets/image/ai/plusB.png'), url('~@/assets/image/ai/plusB.png'),
      url('~@/assets/image/ai/robotL.png'), url('~@/assets/image/ai/robotR.png');
    background-repeat: no-repeat;
    background-position:
      left 18% top 15%, right 18% top 15%,
      left 6% top 30%, right 6% top 30%,
      left 13% top 55%, right 13% top 55%,
      left 10% bottom 0%, right 5% bottom 0%;
    p {
      margin: 0;
    }
    @media (max-width: 1024px) {
      font-size: 1.125rem;
    }
  }
  .intro-text{
    svg {
      width: 1em;
    }
    h6 {
      span {
        color: #F30000;
      }
      @media (max-width: 1024px) {
        font-size: 1rem;
      }
    }
    p {
      margin-bottom: 1.25rem;
      line-height: 150%;
      font-weight: 500;
      @media (max-width: 1024px) {
        font-size: 1rem;
      }
    }
    .title {
      font-weight: 700;
    }
    .icon-img {
      max-width: 1.5em;
      height: auto;
      object-fit: contain;
    }
    .icon-img-sent {
      max-width: 1.3em;
      height: auto;
      object-fit: contain;
    }
  }
  .generate_ul {
    list-style-type: none;
    list-style-position: outside;
    padding-left: 0;
  }
  .chat_ul {
    list-style-type: decimal;
    list-style-position: outside;
    padding-left: 1.1em;
  }
  .chat_ul_none {
    list-style-type: none;
    list-style-position: outside;
    padding-left: 0;
  }
</style>
